import { render } from "./SingleMessage.vue?vue&type=template&id=3b40c192&scoped=true&ts=true"
import script from "./SingleMessage.vue?vue&type=script&lang=ts"
export * from "./SingleMessage.vue?vue&type=script&lang=ts"

import _style_0 from "./SingleMessage.vue?vue&type=style&index=0&id=3b40c192&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-3b40c192"]])

export default __exports__